import { render, staticRenderFns } from "./OrkPasswordJudge.vue?vue&type=template&id=73485f76&scoped=true&"
import script from "./OrkPasswordJudge.vue?vue&type=script&lang=ts&"
export * from "./OrkPasswordJudge.vue?vue&type=script&lang=ts&"
import style0 from "./OrkPasswordJudge.vue?vue&type=style&index=0&id=73485f76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73485f76",
  null
  
)

export default component.exports